import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterApplied = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 12,
	fill: "none",
	viewBox: "0 0 18 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#6750A4",
		d: "M7 12v-2h4v2H7ZM3 7V5h12v2H3ZM0 2V0h18v2H0Z"
	})
});
export { SvgFilterApplied as ReactComponent };
